import React, { useRef, useState } from "react";
import { Form, Image } from "react-bootstrap";
import "../../../Assets/css/myaccount.css";
import "../../../Assets/css/cbLabGrown.css";
import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import { Col, Container, Row } from "react-bootstrap";
import Button from "@mui/material/Button";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { NavLink } from "react-router-dom";
import axios from "axios";
import {
  Address_details,
  base_url,
  media_details,
  postHeader,
} from "../../../Helpers/request";
import swal from "sweetalert";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { IoCallSharp } from "react-icons/io5";
import { TbMailFilled } from "react-icons/tb";
import { HiMail } from "react-icons/hi";
import { FaHome } from "react-icons/fa";
import { FaRegClock } from "react-icons/fa";
import ReCAPTCHA from "react-google-recaptcha";

// import { LuClock10 } from "react-icons/lu";
const Contact = () => {
  const captchaRef = useRef(null);
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [comment, setComment] = useState("");
  const [capchaloading, setCapchaLoading] = useState(true);
  const onChange = (value) => {
    if (value) {
      setCapchaLoading(false);
    }
  };
  const formsubmit = (e) => {
    e.preventDefault();
    captchaRef.current.reset();
    var data = {
      first_name,
      last_name,
      email,
      phone,
      comment,
    };
    console.log("data", data);
    axios
      .post(base_url + "/user/contact", data, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setFirst_name("");
          setLast_name("");
          setEmail("");
          setComment("");
          setPhone("");
          return swal(response.data.message, "", "success");
        } else {
          return swal(response.data.message, "", "error");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      {/* <div className="rcs_myaccount_section">
                <Container>
                    <Row>
                        <Col className="rcs_breadcrumb mb-2">
                            <Breadcrumbs aria-label="breadcrumb">
                                <NavLink underline="hover" color="inherit" to="/">
                                    Home
                                </NavLink>
                                <Typography color="text.primary">Contact Us</Typography>
                            </Breadcrumbs>
                        </Col>
                    </Row>
                </Container>
                <div className="rcs_appointment mt-5">
                    <Container>
                        <Row className="w-100 m-auto">
                            <Col className="p-md-0 mb-5">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3303.8539711487297!2d-84.5206499!3d34.0988812!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f56c0ac68a5d23%3A0x141c89c9f1551b5a!2s8744%20Main%20St%20Unit%20103%2C%20Woodstock%2C%20GA%2030188%2C%20USA!5e0!3m2!1sen!2sin!4v1655103748125!5m2!1sen!2sin" width="100%" height="450" style={{ border: "0" }} allowfullscreen="" loading="lazy"></iframe>
                            </Col>
                        </Row>
                        <h1>Send us a note</h1>
                        <Row className="w-100 m-auto">
                      
                            <Col sm={12} md={6} className="p-md-0">
                                <Form onSubmit={formsubmit}>
                                    <Row>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="First Name"
                                                type="text"
                                                variant="outlined"
                                                value={first_name}
                                                onChange={(e) => setFirst_name(e.target.value)}
                                                required
                                            />
                                        </Col>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Last Name"
                                                type="text"
                                                variant="outlined"
                                                value={last_name}
                                                onChange={(e) => setLast_name(e.target.value)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Email Address"
                                                type="Email"
                                                variant="outlined"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </Col>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Phone"
                                                type="number"
                                                variant="outlined"
                                                InputProps={{ inputProps: { min: 0 } }}
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <TextField
                                                id="filled-multiline-static"
                                                label="Your Message"
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                value={comment}
                                                onChange={(e) => setComment(e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Button variant="contained" type="submit" className="rcs_acc_button"> <MailOutlineIcon className="mr-2" /> Send Message </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                            <Col sm={12} md={6}>
                                <div className="rcs_contact_content">
                                    <h1>We’re here for you!</h1>
                                    <p>Your schedule doesn't match? We are more than happy to schedule an appointment that's convenient for you. Please call and we'll set it up for you.</p>
                                    <p> 
                                    In any case, we highly recommend that you schedule an appointment with Tony or Kathleen so that we can prepare your selection and be 100% focused on you. 
                                    </p>
                                 
                                    <ul className="rcs_content_address">
                                        <li>
                                            <h5>STORE ADDRESS</h5>
                                            <address className="mb-0">
                                            <li onClick={() => { window.open(Address_details.link, '_blank') }}>
   {Address_details.textLine1}
   <br/>
   {Address_details.textLine2}
  </li>
                                               </address>
                                        </li>
                                        <li>
                                            <h5>STORE HOURS</h5>
                                            <strong>Tuesday-Friday:</strong> 10:00 am - 5:00 pm<br />
                                            <strong>Saturday : </strong> 10:00 am - 4:00 pm<br />
                                            <strong>Sunday-Monday</strong> Closed<br />
                                        </li>
                                    </ul>
                                  
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div> */}
      {/* <p>Please send us a message, and our staff will be happy to help you with any questions you have.</p> */}
      {/* <h4>FOLLOW US</h4> */}
      {/* <ul className="rcs_content_social">
                                        {
                                            media_details.map((media ,id)=>
                                            <li key={id}><NavLink onClick={() => window.open(`${media.account_link}`, "_blank")} to="#"><Image src={media.account_img} alt={media.account_alt}></Image></NavLink></li>
                                            )
                                        } */}
      {/* <li><NavLink onClick={() => window.open("https://twitter.com/BelgiumWebnet", "_blank")} to="#"><Image src={Social7} alt="twitter"></Image></NavLink></li>
                                        <li><NavLink onClick={() => window.open("https://www.instagram.com/belgium_webnet/", "_blank")} to="#"><Image src={Social2} alt="Instagram"></Image></NavLink></li>
                                        <li><NavLink onClick={() => window.open("https://www.linkedin.com/company/belgium-webnet/", "_blank")} to="#"><Image src={Social3} alt="Linkdin"></Image></NavLink></li>                                         */}
      {/* </ul> */}
      {/* new page */}
      <div className="cbr_contact_banner"></div>
      <div className="cbr_contact_page">
        <Container fluid>
          <Row>
            <Col sm={12} md={6} lg={6} className="cbr_tealgreenco">
              <div className="cbr_greenarea">
                <h2>We’re here for you!</h2>
                <div className="cbr_contact_box">
                  <div className="cbr_call_contact">
                    <span className="cbr_io_icon">
                      <IoCallSharp />
                      <span className="cbr_social_white hours-font">
                        <a href="tel:+1(678) 722-5664">
                          <span className="text-uppercase white">
                            (678) 722-5664
                          </span>
                        </a>{" "}
                        or
                        <a href="tel:(855) 522-3663"> (855) 522-3663</a>
                      </span>
                    </span>
                  </div>
                  <div className="cbr_call_contact">
                    <span className="cbr_io_icon">
                      <HiMail />
                      {/* <TbMailFilled />  */}
                      <span className="cbr_social_white hours-font">
                        <a
                          href="mailto:sales@culturedbrilliance.com"
                          className="cbr_social_white hours-font"
                        >
                          sales@culturedbrilliance.com
                        </a>
                      </span>
                    </span>
                  </div>
                  <div className="cbr_call_contact">
                    <span className="cbr_io_icon">
                      <FaHome />
                      <span className="cbr_social_white  hours-font">
                        <a
                          href="https://www.google.com/maps/search/8744+Main+St,+Suite+103+Woodstock,+GA+30188/@34.1021644,-84.5400274,15z/data=!3m1!4b1?entry=ttu"
                          className="white hours-font"
                          style={{ border: "none" }}
                        >
                          8744 Main St, Suite 103<br></br>
                          Woodstock, GA 30188
                        </a>
                      </span>
                    </span>
                  </div>
                  <div className="cbr_call_contact">
                    <span className="cbr_io_icon">
                      {/* <FaHome /> */}
                      <FaRegClock />
                      {/* <LuClock/> */}
                      <span className="cbr_social_white  hours-font">
                        {/* <a href="https://www.google.com/maps/search/8744+Main+St,+Suite+103+Woodstock,+GA+30188/@34.1021644,-84.5400274,15z/data=!3m1!4b1?entry=ttu" className="white hours-font"> */}
                  
                        <p>
                        
                        Tuesday to Friday: 10am - 5:30pm <br/>
                        {/* Thursday: 10am - 5pm <br/>
                        Friday: 10am - 5pm <br/> */}
                        Saturday: 10am - 4pm <br/>
                        Sunday - Monday: Closed</p>

                        <p className="mx-600">
                          Your schedule doesn't match? We are more than happy to schedule an appointment that's convenient for you.
                          Please call and we'll set it up for you.
                        </p>
                        <p className="mx-600">
                          In any case, we highly recommend that you schedule and
                          appointment with Tony or Kathleen so that we can
                          prepare your selection and be 100% focused on you.
                        </p>
                        {/* </a> */}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </Col>
            <Col sm={12} md={6} lg={6} className="greybaground_color">
              <div className="rcs_myaccount_section cb_form_outer_box">
                <div className="rcs">
                  <Container>
                    <h1>Send us a note</h1>
                    {/* <Col sm={12} md={12} className=""> */}
                    {/* <Form onSubmit={formsubmit}>
            
                                            <TextField
                                                id="outlined-basic"
                                                label="First Name"
                                                type="text"
                                                variant="outlined"
                                                value={first_name}
                                                onChange={(e) => setFirst_name(e.target.value)}
                                                required
                                            />
                                            <TextField
                                                id="outlined-basic"
                                                label="Email Address"
                                                type="Email"
                                                variant="outlined"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                            <TextField
                                            />
                                            <TextField
                                                id="filled-multiline-static"
                                                label="Your Message"
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                value={comment}
                                                onChange={(e) => setComment(e.target.value)}
                                            />
                        <Button variant="contained" type="submit" className="rcs_acc_button"> <MailOutlineIcon className="mr-2" /> Send Message </Button> 
                                </Form> */}
                    {/* news forms */}
                    <Form onSubmit={formsubmit}>
                      {/* full name */}
                      <Row>
                        <Col sm={12} md={12} lg={12}>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Control aria-label="First Name"
                              id="outlined-basic"
                              placeholder="Full Name"
                              label="First Name"
                              type="text"
                              variant="outlined"
                              value={first_name}
                              onChange={(e) => setFirst_name(e.target.value)}
                              required
                            />
                          </Form.Group>
                        </Col>

                        {/* emaiul */}
                        <Col sm={12} md={12} lg={12}>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Control aria-label="Email Address"
                              id="outlined-basic"
                              placeholder="Email"
                              label="Email Address"
                              type="Email"
                              variant="outlined"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                          </Form.Group>
                        </Col>

                        {/* phone */}
                        <Col sm={12} md={12} lg={12}>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Control aria-label="Phone"
                              placeholder="Phone"
                              id="outlined-basic"
                              label="Phone"
                              type="number"
                              variant="outlined"
                              InputProps={{ inputProps: { min: 0 } }}
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                              required
                            />
                          </Form.Group>
                        </Col>

                        {/* text area */}
                        <Col sm={12} md={12} lg={12}>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                          >
                            <Form.Control aria-label="Message"
                              as="textarea"
                              placeholder="Message"
                              id="filled-multiline-static"
                              label="Your Message"
                              multiline
                              rows={4}
                              variant="outlined"
                              value={comment}
                              onChange={(e) => setComment(e.target.value)}
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={12} lg={12}>
                          <ReCAPTCHA
                            sitekey="6Lc6LUscAAAAAKO2DYPGrIPSnwx3fzROCxJzNWQ0"
                            onChange={onChange}
                            ref={captchaRef}
                            onExpired={() => setCapchaLoading(true)}
                          />
                        </Col>
                        <Col sm={12} md={12} lg={12} className="mt-3">
                          <button
                            variant="contained"
                            type="submit"
                            className="cd_btn_rama_color "
                            disabled={capchaloading ? true : false}
                          >
                            SEND
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </Container>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12} sm={12} lg={12} className="p-0">
              <div className="cbr_location">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3303.8539711487297!2d-84.5206499!3d34.0988812!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f56c0ac68a5d23%3A0x141c89c9f1551b5a!2s8744%20Main%20St%20Unit%20103%2C%20Woodstock%2C%20GA%2030188%2C%20USA!5e0!3m2!1sen!2sin!4v1655103748125!5m2!1sen!2sin"
                  width="100%"
                  height="450"
                  style={{ border: "none" }}
                ></iframe>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Contact;
